import { ecId, ecLean, record, type Row } from '../ability/context';
import { frameCopyOnRead } from '../ability/frame-snapshot';
import type { GmBoundaryVerdict } from '../statuses/gm-boundary';
import { appliedStatusRows } from './applied-status-rows';
import { gmStatusAppliedFrame } from './gm-applied-frame';
import { appliedChargeRows } from './member-applied-frame';
import type { AppliedFrame } from './applied-frame';
/** Reuse the status projector on its lazy changed branches, retaining only writes this decision made. */
export function diceAppliedFrame(operationId: string, encounterId: string, actorId: string, verdict: GmBoundaryVerdict,
    encounter: Row, campaign: Row | null, definition: (id: string) => Row | null): AppliedFrame {
    const roster = (Array.isArray(encounter.encounter_creatures_arr) ? encounter.encounter_creatures_arr : []).filter(record) as Row[];
    const view = frameCopyOnRead(encounter, new Map(roster.map(row => [ecId(row), row])), { catalogs: 'share' });
    const actor = roster.find(row => ecId(row) === actorId);
    const rev = Number(actor ? ecLean(actor, 'movement_rev') ?? 0 : 0) + (verdict.ec[actorId] ? 1 : 0);
    const frame = gmStatusAppliedFrame({ operation_id: operationId, encounter_id: encounterId, actor_id: actorId, rev, member_revs: {} },
        verdict, view.encounter, campaign, definition) as AppliedFrame;
    const statuses = new Set(verdict.statusStacks.map(row => row.status_id));
    frame.rows = [...frame.rows.filter(row => row.table === 'statuses' && statuses.has(row.row_id)),
        ...appliedStatusRows(verdict.statusesAdded, campaign ?? { campaigns: {} }),
        ...Object.entries(verdict.ec).map(([id, changes]) => {
            const held = roster.find(row => ecId(row) === id), movement_rev = Number(held ? ecLean(held, 'movement_rev') ?? 0 : 0) + 1;
            frame.member_revs = { ...frame.member_revs, [id]: movement_rev };
            return { table: 'encounter_creatures', row_id: id, partial: true as const, row: { ...changes, movement_rev } };
        }), ...appliedChargeRows(verdict.charges, roster)];
    if (frame.inputs) delete frame.inputs.member_catalogs;
    // Retain only this delta's encoded values across the asynchronous save.
    return JSON.parse(JSON.stringify(frame)) as AppliedFrame;
}
